import { Fragment } from "react/jsx-runtime";
import type { ChatEntryWithSubTables } from "../../../shared/aiSdkMessages";
import { kickoffDisplay, KickoffMessage } from "./KickoffMessage";
import { ACTIVITY_ROW_GAP, Message } from "./transcriptStyles";
import { UserMessageAttachments } from "./UserMessageAttachments";

export function resolveKickoff(entry: ChatEntryWithSubTables) {
  const kickoffKind = entry.userMessage?.actionKind;
  if (
    entry.entryType === "UserMessage" &&
    entry.userMessage &&
    kickoffKind &&
    (kickoffKind !== "sub_agent" || entry.previousEntryId === null) &&
    kickoffKind in kickoffDisplay
  ) {
    return {
      entryId: entry.id,
      text: entry.userMessage.text,
      attachments: entry.attachments,
      ...kickoffDisplay[kickoffKind as keyof typeof kickoffDisplay],
    };
  }
  return null;
}

type Props = {
  kickoff: NonNullable<ReturnType<typeof resolveKickoff>>;
  dateMarker: React.ReactNode;
  hasPrev: boolean;
  hasNext: boolean;
  activityAbove: boolean;
  activityBelow: boolean;
};

export function KickoffRow({
  kickoff,
  dateMarker,
  hasPrev,
  hasNext,
  activityAbove,
  activityBelow,
}: Props) {
  return (
    <Fragment>
      {dateMarker}
      <Message
        data-chat-entry-id={kickoff.entryId}
        data-user-message-id={kickoff.entryId}
        style={{
          marginTop: hasPrev && !activityAbove ? 16 : 0,
          marginBottom: activityBelow ? ACTIVITY_ROW_GAP : hasNext ? 16 : 0,
        }}
      >
        <KickoffMessage
          text={kickoff.text}
          icon={kickoff.icon}
          label={kickoff.label}
        >
          {kickoff.attachments.length > 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 6,
                marginBottom: 8,
              }}
            >
              <UserMessageAttachments attachments={kickoff.attachments} />
            </div>
          )}
        </KickoffMessage>
      </Message>
    </Fragment>
  );
}
